import CustomButton from "@/components/desktop/button/CustomButton";
import { formatNumber } from "@/utils/numberFormat";

import styles from "./custom-quick-button.module.scss";

const CustomQuickButton = ({ quickActions, customStyles = {} }) => {
	return (
		<div className={styles.quickActions} style={customStyles}>
			{quickActions.map(({ key, label, Icon, onClick, isActive = false, colorScheme, subtitle }) => {
				const customButtonStyle =
					isActive && colorScheme
						? {
								border: `2px solid ${colorScheme.active}`,
								background: "transparent",
								color: colorScheme.active,
							}
						: {};

				return (
					<CustomButton
						key={key}
						variant={isActive ? "primary" : "secondary"}
						size="sm"
						startIcon={Icon ? <Icon strokeWidth={2} size={16} /> : undefined}
						onClick={onClick}
						aria-label={label}
						title={label}
						style={customButtonStyle}
					>
						<span className={styles.btnLabel}>{label}</span>
						{subtitle && <span className={styles.subtitle}>{!isNaN(Number(subtitle)) ? `${formatNumber(subtitle)} Ha` : subtitle}</span>}
					</CustomButton>
				);
			})}
		</div>
	);
};

export default CustomQuickButton;
